module.exports = __webpack_public_path__ + "static/media/cards-b.aa375542.svg";